import { render, staticRenderFns } from "./ShowRiskFormModal.vue?vue&type=template&id=40b1be36&scoped=true"
import script from "./ShowRiskFormModal.vue?vue&type=script&lang=js"
export * from "./ShowRiskFormModal.vue?vue&type=script&lang=js"
import style0 from "./ShowRiskFormModal.vue?vue&type=style&index=0&id=40b1be36&prod&lang=css"
import style1 from "./ShowRiskFormModal.vue?vue&type=style&index=1&id=40b1be36&prod&scoped=true&lang=css"
import style2 from "./ShowRiskFormModal.vue?vue&type=style&index=2&id=40b1be36&prod&lang=css"
import style3 from "./ShowRiskFormModal.vue?vue&type=style&index=3&id=40b1be36&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b1be36",
  null
  
)

export default component.exports